/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { VariantOption } from './VariantOption';
import {
    VariantOptionFromJSON,
    VariantOptionFromJSONTyped,
    VariantOptionToJSON,
} from './VariantOption';
import type { VariantType } from './VariantType';
import {
    VariantTypeFromJSON,
    VariantTypeFromJSONTyped,
    VariantTypeToJSON,
} from './VariantType';

/**
 * 
 * @export
 * @interface AddonModel
 */
export interface AddonModel {
    /**
     * 
     * @type {string}
     * @memberof AddonModel
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof AddonModel
     */
    googleProductCategory?: string;
    /**
     * 
     * @type {{ [key: string]: VariantOption | undefined; }}
     * @memberof AddonModel
     */
    options?: { [key: string]: VariantOption | undefined; };
    /**
     * 
     * @type {string}
     * @memberof AddonModel
     */
    productType?: string;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof AddonModel
     */
    variantPrices?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {Array<VariantType>}
     * @memberof AddonModel
     */
    variantTypes?: Array<VariantType>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddonModel
     */
    images?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Price | undefined; }}
     * @memberof AddonModel
     */
    priceDictionary?: { [key: string]: Price | undefined; };
    /**
     * 
     * @type {Price}
     * @memberof AddonModel
     */
    price?: Price;
    /**
     * 
     * @type {string}
     * @memberof AddonModel
     */
    id?: string;
}

/**
 * Check if a given object implements the AddonModel interface.
 */
export function instanceOfAddonModel(value: object): boolean {
    return true;
}

export function AddonModelFromJSON(json: any): AddonModel {
    return AddonModelFromJSONTyped(json, false);
}

export function AddonModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddonModel {
    if (json == null) {
        return json;
    }
    return {
        
        'brand': json['brand'] == null ? undefined : json['brand'],
        'googleProductCategory': json['googleProductCategory'] == null ? undefined : json['googleProductCategory'],
        'options': json['options'] == null ? undefined : (mapValues(json['options'], VariantOptionFromJSON)),
        'productType': json['productType'] == null ? undefined : json['productType'],
        'variantPrices': json['variantPrices'] == null ? undefined : json['variantPrices'],
        'variantTypes': json['variantTypes'] == null ? undefined : ((json['variantTypes'] as Array<any>).map(VariantTypeFromJSON)),
        'images': json['images'] == null ? undefined : json['images'],
        'priceDictionary': json['priceDictionary'] == null ? undefined : (mapValues(json['priceDictionary'], PriceFromJSON)),
        'price': json['price'] == null ? undefined : PriceFromJSON(json['price']),
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function AddonModelToJSON(value?: AddonModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'brand': value['brand'],
        'googleProductCategory': value['googleProductCategory'],
        'options': value['options'] == null ? undefined : (mapValues(value['options'], VariantOptionToJSON)),
        'productType': value['productType'],
        'variantPrices': value['variantPrices'],
        'variantTypes': value['variantTypes'] == null ? undefined : ((value['variantTypes'] as Array<any>).map(VariantTypeToJSON)),
        'images': value['images'],
        'priceDictionary': value['priceDictionary'] == null ? undefined : (mapValues(value['priceDictionary'], PriceToJSON)),
        'price': PriceToJSON(value['price']),
        'id': value['id'],
    };
}

